export const isStagingOrLocalhost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  return (
    host === 'traffic-lite-front-end-staging.netlify.app' ||
    host === 'traffic-lite-production.netlify.app' ||
    host === 'traffic-lite.netlify.app' ||
    host === 'trafficliteedu.com' ||
    host === 'www.trafficliteedu.com' ||
    host === 'localhost' ||
    host === '127.0.0.1'
  );
};

